import React from 'react';

import * as xlsx from 'xlsx';

import { useSnackbar } from 'notistack';

import { Icon } from '@iconify/react';

import { Button, Stack } from '@mui/material';

import { createWithURLSearchParams } from '../../fetch';
import { useTranslation } from '../../common/LocalizationProvider';

export default function AerosImport() {
  const { enqueueSnackbar } = useSnackbar();
  const t = useTranslation();

  async function readUploadFile(e) {
    e.preventDefault();
    if (e.target.files) {
      const reader = new FileReader();
      reader.onload = (e) => {
        const data = e.target.result;
        const workbook = xlsx.read(data, { type: 'array' });
        const sheetName = workbook.SheetNames[0];
        const worksheet = workbook.Sheets[sheetName];
        const json = xlsx.utils.sheet_to_json(worksheet);
        handleClickImportAeros(json);
      };
      reader.readAsArrayBuffer(e.target.files[0]);
    }
  }

  const handleClickImportAeros = async (data) => {
    const response = await createWithURLSearchParams('aeros/excel', `data=${JSON.stringify(data)}`);
    if (response.ok) {
      enqueueSnackbar(t('FL_Import_Snackbar'), { variant: 'success' });
    } else {
      const error = await response.text();
      const message = error.slice(0, error.indexOf('-'));
      enqueueSnackbar(message, { variant: 'error' });
    }
  };

  return (
    <Stack>
      <input
        accept=".xlsx"
        style={{ display: 'none' }}
        onChange={readUploadFile}
        id="icon-button-file"
        type="file"
        multiple={false}
        value=""
      />
      <label htmlFor="icon-button-file">
        <Button
          variant="contained"
          disableRipple
          component="span"
          startIcon={<Icon icon="ic:baseline-upload-file" />}
          color="info"
        >
          {t('new_aeros')}
        </Button>
      </label>
    </Stack>
  );
}
